import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=a0a576d8&scoped=true&lang=pug&"
import script from "./StoreDetail.vue?vue&type=script&lang=ts&"
export * from "./StoreDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=a0a576d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a576d8",
  null
  
)

export default component.exports